/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemsRefetchWrapper_portfolioNode$ref = any;
type Recommendations_trending$ref = any;
type RequestShippingQuoteModal_viewer$ref = any;
type Tiles_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type FolderContainer_viewer$ref: FragmentReference;
export type FolderContainer_viewer = {|
  +id: string,
  +user?: ?{|
    +serviceId: ?string,
    +isVerifiedTrade: ?boolean,
    +profile: ?{|
      +currency: ?Currency,
      +email: ?string,
    |},
  |},
  +folderPortfolios?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +serviceId: ?string,
        +name: ?string,
        +description: ?string,
        +isPublic: ?boolean,
        +ownerId: ?string,
        +totalPortfolioItems: ?{|
          +totalResults: ?number
        |},
        +$fragmentRefs: ItemsRefetchWrapper_portfolioNode$ref,
      |}
    |}>
  |},
  +project?: ?{|
    +portfolio: ?{|
      +id: string,
      +serviceId: ?string,
      +name: ?string,
      +description: ?string,
      +isPublic: ?boolean,
      +ownerId: ?string,
      +totalPortfolioItems: ?{|
        +totalResults: ?number
      |},
      +$fragmentRefs: ItemsRefetchWrapper_portfolioNode$ref,
    |}
  |},
  +$fragmentRefs: Recommendations_trending$ref & RequestShippingQuoteModal_viewer$ref & Tiles_viewer$ref,
  +$refType: FolderContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 1,
  "type": "Int"
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isPublic",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "ownerId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": "totalPortfolioItems",
    "name": "items",
    "storageKey": "items(first:1)",
    "args": [
      (v2/*: any*/)
    ],
    "concreteType": "PortfolioItemsConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "FragmentSpread",
    "name": "ItemsRefetchWrapper_portfolioNode",
    "args": null
  }
];
return {
  "kind": "Fragment",
  "name": "FolderContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "portfolioIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "useProjectEndpoint",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "projectId",
      "type": "String!"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Recommendations_trending",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "RequestShippingQuoteModal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Tiles_viewer",
      "args": null
    },
    (v0/*: any*/),
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "useProjectEndpoint",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "project",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "projectId",
              "type": "String!"
            }
          ],
          "concreteType": "Project",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "portfolio",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "plural": false,
              "selections": (v3/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "useProjectEndpoint",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "folderPortfolios",
          "name": "portfolios",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            {
              "kind": "Variable",
              "name": "portfolioIds",
              "variableName": "portfolioIds",
              "type": "[String]"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "plural": false,
                  "selections": (v3/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isVerifiedTrade",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "profile",
              "storageKey": null,
              "args": null,
              "concreteType": "Profile",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd6d5634efb2439c3becb88aaa03f9569';
module.exports = node;
